<template>
	<div>
		<!-- 头部logo -->
		<headLogo @navigation="navigation"></headLogo>
		
		<!-- 头部导航 -->
		<navigation :headTitle="headTitle" :headImg="headImg" style="margin-top:96px;"></navigation>
		
		<div class="presidentmessage">
			<el-row class="president-imgdata">
				<el-row>
					<img :src="leaderNotLoadImage" :onload="onLoadImg(img)" class="president-img"></img>
				</el-row>
			</el-row>
				
			<el-row class="president-message">
				<el-col :span="24" v-html="list.bodyContent">
					{{list.bodyContent}}
				</el-col>
			</el-row>
		</div>
		
		<!-- 菜单导航 -->
		<meauDialog :meauValue="navigationvalue" @meauFn="menu"></meauDialog>
		
		<!-- 底部导航 -->
		<bottomNavigation></bottomNavigation>
	</div>
</template>

<script>
	// 图片查询接口
	import { selectPictureListById , selectContentListById } from '@/api/index.js'

	// 头部组件
	import headLogo from '@/components/headLogo.vue'
	// 头部导航
	import navigation from '@/components/navigation.vue'
	// 底部导航
	import bottomNavigation from '@/components/bottomNavigation.vue'
	// 菜单导航
	import meauDialog from '@/components/meauDialog.vue'
	export default
	{
		data()
		{
			return{
				// 头部导航标题
				headTitle:"CHAIR'S MESSAGE",
				// 头部导航图片
				headImg:'/index/message.png',
				// 导航值
				navigationvalue:false,
			
				list:{},
				img:'/PCimage/375_500.jpg',
				leaderNotLoadImage: "/PCimage/375_500.jpg", //领导图片未加载出来
			}
		},
		components:
		{
			headLogo,
			navigation,
			bottomNavigation,
			meauDialog
		},
		created()
		{
			this.imgList()
		},
		methods:
		{
			// 总经理图片
			imgList()
			{
				selectContentListById(
				{
				  chnanelType: 1,
				  isIndex: 0,
				  moduleType: 'MODULE_MESSAGE'
				})
				.then((response)=>
				{
					if(response.data.data=='')
					{
						this.$router.push(
						{
							path:'/error',
							item:2,
						})
					}
					else
					{
						this.list=response.data.data[0];
						this.img=response.data.data[0].pictureUrl;
					}
				})
			},
			// 头部传来的数据
			navigation(v)
			{
				this.navigationvalue=v;
				console.log(this.navigationvalue,'头部传递菜单导航')
			},
			// 遮罩层传回来的数据
			menu(v)
			{
				this.navigationvalue=v;
			},
			// 图片加载完成时触发
			onLoadImg(imgSrc) 
			{
				return 'this.src='+'"'+imgSrc+'";this.οnlοad=null';
			},
		}
	}
</script>

<style scoped>
	.presidentmessage{
		width: 60%;
		margin-left: 20%;
	}
	.president-imgdata{
		width: 100%;
		position: relative;
	}
	.president-img{
		width: 375px;
		height: 500px;
	}
	.president-message{
		margin-top: 69px;
		text-align: left;
		line-height: 30px;
		display: inline-block;
		text-align: justify;
		text-justify: distribute-all-lines;
		word-wrap:break-word;
		white-space: pre-wrap;
	}
	.president-englishName{
		margin-top: 50px;
		font-size: 30px;
		text-align: left;
	}
	.president-position{
		margin-top: 20px;
		text-align: left;
	}
	.president-data{
		height: 50px;
		background-color: rgba(12,12,12,0.5);
		position: absolute;
		bottom: 3px;
		line-height: 50px;
		color: white;
		font-size: 20px;
		text-align: center;
		padding-left: 3px;
		padding-right: 3px;
	}
</style>